module.exports = __webpack_public_path__ + "img/IMG_8618_FoamcoreMatted.ad9a4994.jpg";